// Centralized lifetime promo codes for consistent checking across the application
export const LIFETIME_PROMO_CODES = [
  "zoeeforever",
  "ZOEEFOREVER",
  "stakeholderfreeforever", 
  "STAKEHOLDERFREEFOREVER",
  "500forever",
  "500FOREVER",
  "foundingcoach100",
  "FOUNDINGCOACH100",
]

// Helper function to check if a promo code is a lifetime subscription
export const isLifetimeSubscription = (promoCode: string | undefined | null): boolean => {
  if (!promoCode) return false
  return LIFETIME_PROMO_CODES.includes(promoCode.toLowerCase())
}
